module.exports = __webpack_public_path__ + "static/media/tcp-frame.bd44fc99.png";